import React from 'react';
import TrueImpactModal, {
  modalHeightAutoStyles,
  modalRadiusStyles,
  TrueImpactModalProps,
} from './TrueImpactModal';
import styled from 'styled-components';
import { SPACERS } from '../settings/variables/Spacers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition, IconProp } from '@fortawesome/fontawesome-svg-core';
import { COLORS } from '../settings/variables/Colors';

interface TrueImpactConfirmationDialogProps {
  open: boolean;
  padding?: string;
  handleClose: () => unknown;
  icon?: IconProp | IconDefinition;
  iconColor?: keyof typeof COLORS;
  next: TrueImpactModalProps['next'];
  previous: TrueImpactModalProps['previous'];
  maxWidth?: TrueImpactModalProps['maxWidth'];
  children: React.ReactNode | React.ReactNode[] | string | number;
}

const StyledDiv = styled.div<{ padding: string }>`
  ${({ padding }) => `padding: ${padding};`}
  .model-big-icon-wrapper {
    text-align: center;
    .model-big-icon {
      margin-bottom: ${SPACERS.small};
    }
  }
`;

const TrueImpactConfirmationDialog: React.FC<TrueImpactConfirmationDialogProps> = ({
  open,
  icon,
  next,
  previous,
  children,
  handleClose,
  maxWidth = '700px',
  iconColor = 'ctaPrimary',
  padding = icon ? SPACERS.extraLarge : SPACERS.medium,
}) => {
  return (
    <TrueImpactModal
      open={open}
      next={next}
      hideHeader={true}
      previous={previous}
      maxWidth={maxWidth}
      onClose={handleClose}
      addStyles={modalHeightAutoStyles + modalRadiusStyles}
    >
      <StyledDiv padding={padding}>
        {icon && (
          <div className="model-big-icon-wrapper">
            <FontAwesomeIcon
              size="3x"
              icon={icon}
              color={COLORS[iconColor]}
              className="model-big-icon"
            />
          </div>
        )}
        {children}
      </StyledDiv>
    </TrueImpactModal>
  );
};

export default TrueImpactConfirmationDialog;
